var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCusSel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8C6.19226 8 6.86897 7.79471 7.44456 7.4101C8.02014 7.02549 8.46875 6.47883 8.73363 5.83925C8.99852 5.19967 9.0678 4.49591 8.9327 3.81696C8.7976 3.13801 8.4642 2.51437 7.97466 2.02491C7.48511 1.53545 6.86141 1.20216 6.18244 1.06718C5.50347 0.932199 4.79971 1.0016 4.16018 1.2666C3.52065 1.5316 2.97407 1.9803 2.58956 2.55595C2.20505 3.1316 1.99988 3.80835 2 4.50061C2.00097 5.42852 2.37005 6.31813 3.02624 6.97419C3.68242 7.63026 4.5721 7.99919 5.5 8Z",
    fill: "url(#paint0_linear_10_1299)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44172 10.6538C8.67807 9.87401 7.69825 9.33854 6.62743 9.11579C5.5566 8.89305 4.44339 8.99314 3.42999 9.40329C2.41658 9.81343 1.54899 10.515 0.938033 11.4184C0.327077 12.3218 0.000494305 13.386 0 14.475C0 14.6143 0.0555571 14.7478 0.154449 14.8462C0.253342 14.9447 0.387468 15 0.527323 15H10.4726C10.6125 15 10.7466 14.9447 10.8455 14.8462C10.9444 14.7478 11 14.6143 11 14.475C11.002 13.9184 10.9157 13.3649 10.7442 12.835C10.4889 12.0159 10.0426 11.2685 9.44172 10.6538Z",
    fill: "url(#paint1_linear_10_1299)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7Z",
    fill: "url(#paint2_linear_10_1299)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0198 9C11.3084 9.00237 10.6109 9.17416 10 9.49741C10.1152 9.58871 10.2314 9.67859 10.3402 9.77741C11.0628 10.436 11.5996 11.2368 11.9068 12.1144C12.012 12.4033 12.0896 12.6995 12.1387 13H15.4693C15.6101 13 15.745 12.9504 15.8446 12.8622C15.9441 12.7739 16 12.6542 16 12.5294C15.9989 11.5937 15.5792 10.6965 14.833 10.0348C14.0868 9.37316 13.0751 9.001 12.0198 9Z",
    fill: "url(#paint3_linear_10_1299)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_1299",
    x1: 5.5,
    y1: 1,
    x2: 5.5,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_1299",
    x1: 5.5,
    y1: 9,
    x2: 5.5,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10_1299",
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10_1299",
    x1: 13,
    y1: 9,
    x2: 13,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCusSel);
export default __webpack_public_path__ + "static/media/cusSel.9604aaae695bbb053c6b3f5c2c51a180.svg";
export { ForwardRef as ReactComponent };